import {LOGIN, LOG_OUT,USER_DATA} from '../types';
import moment from 'moment-jalali';
import Cookies from "universal-cookie";
const cookies = new Cookies();

export const initialState = {
    login: false,
    data: [],
    user:[]
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOG_OUT:
            cookies.remove('auth');
            return {
                ...state,
                login: false,
                data: []
            };
        case LOGIN:
            cookies.set('auth', action.payload);
            return {
                ...state,
                login: true,
                data: action.payload
            };
        case USER_DATA:
            return {
                ...state,
                user: action.payload
            };
        default:
            return state;
    }
}
